<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'login'
    }
</script>

<style>
    body {
        background-color: #1c2125;
    }

    div.request-permission {
        margin-top: 5px
    }

    div.text-label {
        text-align: center;
        padding-top: 1%;
    }

    input[type="checkbox"] {
        cursor: pointer;
    }
</style>
